import {
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { INVENTORY_FORM_FIELDS } from 'utils/constants'
import { formatDate, getDepartment, getFamily, getSection } from 'utils/helpers'
const {
  ITEM_NUMBER,
  BARCODE,
  DEPARTMENT,
  ERP_BRAND,
  ERP_ITEM_DESC,
  ERP_PACK_INFO,
  ERP_UOM,
  FAMILY,
  ONLINE_DESC,
  ONLINE_PACK_INFO,
  QTY_PER_UOM,
  SECTION,
  SUB_FAMILY,
  ERP_QTY,
  LAST_QTY_UPDATE,
  OOS_THRESHOLD,
  SELLABLE_QTY,
  STORE_ID,
  STORE_NAME,
  ON_STOCK,
} = INVENTORY_FORM_FIELDS

export const columns = [
  {
    headerName: STORE_NAME.label,
    field: `store.${STORE_NAME.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },

  {
    headerName: STORE_ID.label,
    field: 'store._id',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: BARCODE.label,
    field: `catalogue._id`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ITEM_NUMBER.label,
    field: `catalogue.${ITEM_NUMBER.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ERP_BRAND.label,
    field: `catalogue.${ERP_BRAND.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: DEPARTMENT.label,
    field: `catalogue.${DEPARTMENT.key}`,
    valueFormatter: (params: ValueFormatterParams) => {
      return getDepartment(params.value)
    },
  },
  {
    headerName: SECTION.label,
    field: `catalogue.${SECTION.key}`,
    valueFormatter: (params: ValueFormatterParams) => {
      return getSection(params.value)
    },
  },
  {
    headerName: FAMILY.label,
    field: `catalogue.${FAMILY.key}`,
    valueFormatter: (params: ValueFormatterParams) => {
      return getFamily(params.value)
    },
  },
  {
    headerName: SUB_FAMILY.label,
    field: `catalogue.${SUB_FAMILY.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ONLINE_DESC.label,
    field: `catalogue.${ONLINE_DESC.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },

  {
    headerName: ERP_ITEM_DESC.label,
    field: `catalogue.${ERP_ITEM_DESC.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ONLINE_PACK_INFO.label,
    field: `catalogue.${ONLINE_PACK_INFO.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },

  {
    headerName: ERP_UOM.label,
    field: `catalogue.${ERP_UOM.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: QTY_PER_UOM.label,
    field: `catalogue.${QTY_PER_UOM.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: LAST_QTY_UPDATE.label,
    field: LAST_QTY_UPDATE.key,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatDate(params.value, { includeTime: true }) : '-',
  },
  {
    headerName: ERP_QTY.label,
    field: ERP_QTY.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ERP_PACK_INFO.label,
    field: `catalogue.${ERP_PACK_INFO.key}`,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: OOS_THRESHOLD.label,
    field: OOS_THRESHOLD.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: SELLABLE_QTY.label,
    field: SELLABLE_QTY.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ON_STOCK.label,
    field: ON_STOCK.key,
    cellRenderer: (params: ICellRendererParams) => {
      return params?.value === true
        ? 'Yes'
        : params?.value === false
          ? 'No'
          : '-'
    },
  },
]
